module.exports = __webpack_public_path__ + "static/media/next-question.459733fb.svg";